import { render, staticRenderFns } from "./acl.vue?vue&type=template&id=19f65a6e&"
import script from "./acl.vue?vue&type=script&lang=js&"
export * from "./acl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports